import React from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersObject, PaginationDelegate } from 'store/general/paginationDelegate';
import { SubscriberAddOnMethod, SubscribersSortBy, SubscribersSortOrder } from 'types/electionService';
import { FilterDropdown } from 'components/common/general/CollectionManagementPanel/FilterDropdown';
import { ADD_ON_METHOD_FILTER_DROPDOWN_TEST_IDS } from '../constants';

const STATUS_FILTER_TITLES = {
  [SubscriberAddOnMethod.CENSUS]: 'Census',
  [SubscriberAddOnMethod.FORM]: 'Form',
  [SubscriberAddOnMethod.LINK]: 'Link',
};

export interface InitiateAddEmployeesFilters extends FiltersObject {
  addOnMethod: SubscriberAddOnMethod | null;
}

interface Props {
  paginationDelegate: PaginationDelegate<SubscribersSortBy, SubscribersSortOrder, InitiateAddEmployeesFilters>;
}

export const AddOnFilterDropdown: React.FC<Props> = observer(({ paginationDelegate }) => {
  if (!!paginationDelegate.filters.addOnMethod && !STATUS_FILTER_TITLES[paginationDelegate.filters.addOnMethod]) {
    throw new Error(`Unsupported filter value assigned! ${paginationDelegate.filters.addOnMethod}`);
  }
  return (
    <FilterDropdown
      filterName="Added Method"
      $minWidth="26rem"
      optionsWidth="26rem"
      selectedFilterLabel={
        paginationDelegate.filters.addOnMethod ? STATUS_FILTER_TITLES[paginationDelegate.filters.addOnMethod] : 'All'
      }
      filtersList={[
        { value: null, label: 'All' },
        {
          value: SubscriberAddOnMethod.CENSUS,
          label: STATUS_FILTER_TITLES[SubscriberAddOnMethod.CENSUS],
        },
        {
          value: SubscriberAddOnMethod.FORM,
          label: STATUS_FILTER_TITLES[SubscriberAddOnMethod.FORM],
        },
        {
          value: SubscriberAddOnMethod.LINK,
          label: STATUS_FILTER_TITLES[SubscriberAddOnMethod.LINK],
        },
      ]}
      applyFilter={(value: string | null) => {
        paginationDelegate.setFilterValue('addOnMethod', value as SubscriberAddOnMethod);
      }}
      data-test-id={ADD_ON_METHOD_FILTER_DROPDOWN_TEST_IDS.DROPDOWN_OPTIONS}
    />
  );
});
